'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadJs = exports.loadCss = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview 加载文件相关
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */

var _index = require('../function/index');

/**
 * 加载css
 * @param {Object} config 对应的配置信息
 * @param {String} config.url          链接
 * @param {Function} config.onload 加载成功回调
 * @param {Function} config.onerror 加载失败回调
 * @return {Void} link
 */
var loadCss = exports.loadCss = function loadCss() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$url = config.url,
        url = _config$url === undefined ? '' : _config$url,
        _config$onload = config.onload,
        onload = _config$onload === undefined ? _index.noop : _config$onload,
        _config$onerror = config.onerror,
        onerror = _config$onerror === undefined ? _index.noop : _config$onerror;

    var loadNode = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.head;
    var link = null;

    if (loadNode) {
        link = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.onload = function () {
            onload(config);
        };
        link.onerror = function () {
            onerror(config);
        };
        link.href = url;
        loadNode.appendChild(link);
    }
    return link;
};

/**
 * 加载js
 * @param {Object} config 对应的配置信息
 * @param {String} config.url          链接
 * @param {Function} config.onload 加载成功回调
 * @param {Function} config.onerror 加载失败回调
 * @return {Void} script
 */
var loadJs = exports.loadJs = function loadJs() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$url2 = config.url,
        url = _config$url2 === undefined ? '' : _config$url2,
        _config$onload2 = config.onload,
        onload = _config$onload2 === undefined ? _index.noop : _config$onload2,
        _config$onerror2 = config.onerror,
        onerror = _config$onerror2 === undefined ? _index.noop : _config$onerror2;

    var script = null,
        loadNode = null;

    loadNode = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.body;
    // 如果是把js放置在head，body是没有的
    if (!loadNode) {
        loadNode = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.head;
    }

    if (loadNode) {
        script = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.createElement('script');
        script.onload = function () {
            onload(config);
        };
        script.onerror = function () {
            onerror(config);
        };
        script.src = url;

        if (loadNode) {
            loadNode.appendChild(script);
        }
    }
    return script;
};

exports.default = {
    loadCss: loadCss,
    loadJs: loadJs
};